import css from './index.module.scss'
import { IEmpty } from './types'

/** Компонент Empty */
export const Empty = ({ 
    image, 
    title, 
    size = "150px", 
    color = 'var(--foreground_default)', 
    fontSize = '14px', 
    isRendered = true,
    isVisible = true,
}: IEmpty) => {
    /** Стили компоненты */
    const componentStyle: React.CSSProperties = {
        display: isVisible ? 'flex' : 'none',
    }

    return <>
        {isRendered &&
            <div className={css.wrapper} style={componentStyle}>
                <div className={css.container}>
                    <img src={`${image}`} alt="Данные отсутствуют" style={{ height: `${size}` }} />
                    <div className={css.title} style={{ color: `${color}`, fontSize: `${fontSize}` }}>{title}</div>
                </div>
            </div>
        }
    </>
}